import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { SendResetPasswordLinkRequest } from '$/requests/SendResetPasswordLink.ts';

const useSendResetPasswordLink = () => {
  const client = supabaseClient;

  const mutationFn = async (request: SendResetPasswordLinkRequest) => {
    return sendResetPasswordLink(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useSendResetPasswordLink;

async function sendResetPasswordLink(
  client: SupabaseClient,
  request: SendResetPasswordLinkRequest
): Promise<BackendSuccessResponse<{ message: string }>> {
  const { data, error } = await client.functions.invoke('send_reset_password_link', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
